export const LOAD_PERIMETER_TYPES = 'LOAD_PERIMETER_TYPES'